import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


export default function ControlledAccordions({ title, desc }) {
  const [expanded, setExpanded] = React.useState(false);

  const [toggleIcon, settoggleIcon] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    settoggleIcon(!toggleIcon)
  };

  return (
    <div>
      <Accordion className='lg:!p-0 sm:!p-0 2xl:!p-3' sx={{ background: "#FFD700", borderRadius: "0.6rem !important", padding: "0.2rem", border: "none", boxShadow: "none" }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={toggleIcon ? <RemoveIcon className='bg-black text-white rounded-sm text-sm' /> : <AddIcon className='bg-white text-black rounded-sm' />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className="lg:!text-[18px] sm:!text-[16px] lg:!text-sm xl:h-[3rem] px-1 2xl:text-[22px] xl:!text-[16px] flex items-center" sx={{ width: '100%', flexShrink: 0, fontWeight: "bold" }}>
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='lg:!text-sm !-mt-4 sm:!-mt-6' sx={{ fontSize: "18px", lineHeight: "30px" }}>
            {desc}
          </Typography>
        </AccordionDetails>
      </Accordion>

    </div>
  );
}
